<template>
    <button type="button" class="btn btn-primary">
        <slot />
    </button>
</template>
